import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import { DealDocumentsData } from '@services/requests/dealPageService/types/documentsData';
import React, { useState } from 'react';

import { DocumentsTab } from '../DealPageTabs/DocumentsTab';
import { a11yProps } from './helpers';
import { CompanyProfileTabsStyledContainer } from './StyledComponents';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

interface DealPageTabsContainerProps {
  documentsData: DealDocumentsData;
  isAllowEdit: boolean;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}

const DealPageTabsContainer = ({ documentsData, isAllowEdit }: DealPageTabsContainerProps) => {
  const [activeTabIndex, setActiveTabIndex] = useState<number>(0);

  return (
    <>
      <CompanyProfileTabsStyledContainer>
        <Tabs
          variant="scrollable"
          scrollButtons="auto"
          value={activeTabIndex}
          onChange={(_, v) => setActiveTabIndex(v)}
          className={'root-deal-page-tabs'}
        >
          {documentsData.tabs.map((tab, index) => (
            <Tab key={'deal-tab-' + index} label={tab.title} {...a11yProps(0)} />
          ))}
        </Tabs>
        <div className="root-deal-page-tabs__wrapper">
          <CustomTabPanel value={activeTabIndex} index={0}>
            <DocumentsTab documentsData={documentsData} isAllowEdit={isAllowEdit} />
          </CustomTabPanel>
        </div>
      </CompanyProfileTabsStyledContainer>
    </>
  );
};

export { DealPageTabsContainer };
